import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import moment from 'moment';
import {Box, Typography} from '@mui/material';
import {CheckRounded, CloseRounded, PriorityHighRounded} from '@mui/icons-material';
import {CareTaskComplementary} from '../../../backend/interfaces/care-task-complementary';
import {CaregiverTaskCompletion} from '../../../enums';

export const getTaskStatus = ({careTask}: CareTaskComplementary): CaregiverTaskCompletion => {
  if (
    (careTask?.markedAsDone !== undefined || careTask?.markedAsDone !== null) &&
    careTask.markedAsHandled
  ) {
    return careTask?.markedAsDone ? CaregiverTaskCompletion.DONE : CaregiverTaskCompletion.NOT_DONE;
  } else {
    const taskDate = moment(careTask.startsAt);
    const now = moment();

    if (careTask.markedAsHandled) {
      return CaregiverTaskCompletion.DONE;
    } else {
      if (now.isAfter(taskDate)) {
        return CaregiverTaskCompletion.MISSED;
      }
      return CaregiverTaskCompletion.PLANNED;
    }
  }
};

interface TaskStatusProps {
  task: CareTaskComplementary;
  min?: boolean;
  pendingCareTaskId?: string;
}

export const TaskStatus = ({task, min = false, pendingCareTaskId}: TaskStatusProps) => {
  const {t} = useTranslation();

  const value = getTaskStatus(task);

  const label = t(
    translations.care_and_activities.status_types[
      pendingCareTaskId && value !== 'done' ? 'done' : value
    ]
  );

  const Icon = () => {
    if (pendingCareTaskId && value !== 'done') return <CheckRounded />;

    switch (value) {
      case CaregiverTaskCompletion.DONE:
        return <CheckRounded />;
      case CaregiverTaskCompletion.NOT_DONE:
        return <CloseRounded />;
      case CaregiverTaskCompletion.MISSED:
        return <PriorityHighRounded />;

      default:
        return <></>;
    }
  };

  return (
    <Box
      className={`care-table-row-cell care-table-row-cell-status-${pendingCareTaskId && value !== 'done' ? 'done-system' : value}`}
    >
      <Box
        className="care-table-row-cell-status-icon"
        sx={{
          '> svg': {
            height: min ? '22px' : '16px',
            width: min ? '22px' : '16px',
          },
        }}
      >
        <Icon />
      </Box>
      {!min && <Typography className="care-table-row-cell-status-label">{label}</Typography>}
    </Box>
  );
};
